import _default from "./_default";
import menu from "./menu";
import home from "./home";

export type TopBarTypes = "default" |  "menu" | "home"
export default {
    "default": _default,
    menu,
    home
}